/* eslint-disable react-hooks/exhaustive-deps */
import LoadingWrap from '@/components/LoadingWrap';
import { QueryKey } from '@/constants/queryKey';
import floorService from '@/services/floor.service';
import { notification } from 'antd';
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import MainContent from './Content';
import MainFooter from './Footer';
import MainHeader from './Header';
import './style.scss';

export interface SelectRoom {
    _id: string;
    status: string;
    name: string;
    entryNo?: string;
    timeCheckIn?: string;
    roomGroup?: number;
    roomStatusId?: string;
}

const Main = () => {
    const [selectedRoom, setSelectedRoom] = useState<SelectRoom[]>([]);
    const [floorActive, setFloorActive] = useState<string | number>(localStorage.getItem('floorID') || '');
    const [filterStatus, setStatus] = useState<number[] | undefined>();

    const { data: dataListFloor } = useQuery([QueryKey.listFloor], floorService.getListFloor, {
        // cacheTime: 0,
        // staleTime: 100 * 1000,
        onSuccess: () => {
            if (floorActive) refetch();
        },
    });

    const { data: dataListRoom, refetch } = useQuery(
        [QueryKey.listRoom, floorActive],
        () => floorService.getRoomByFloor(floorActive?.toString() || '', filterStatus),
        {
            enabled: !!floorActive,
            cacheTime: 0,
            // staleTime: 100 * 1000,
            onError: (error: any) => {
                const key = error?.response?.data?.message;
                notification.error({
                    message: key,
                });
            },
        },
    );

    const { data: statusRoom, refetch: refetchStatus } = useQuery(
        ['status-room', floorActive],
        () => floorService.getInfo(),
        {
            enabled: !!floorActive,
            cacheTime: 0,
            onError: (error: any) => {
                const key = error?.response?.data?.message;
                notification.error({
                    message: key,
                });
            },
        },
    );

    useEffect(() => {
        if (dataListFloor && dataListFloor.length && !floorActive) {
            setFloorActive(dataListFloor[0]._id);
            return;
        }
        if (dataListFloor && dataListFloor.length && floorActive) {
            refetch();
            return;
        }
    }, [dataListFloor]);

    const onSelectRoom = (value: SelectRoom) => {
        if (value) setSelectedRoom([...selectedRoom, value]);
    };

    const removeSelectRoom = (value: string) => {
        setSelectedRoom(selectedRoom.filter((item: any) => item?._id !== value));
    };

    const removeAllSelectRoom = () => {
        if (selectedRoom.length > 0) setSelectedRoom([]);
    };

    const onFloorChange = (id: string) => {
        localStorage.setItem('floorID', `${id}`);
        setFloorActive(id);
    };

    const onChangeStatus = (ids: number[]) => {
        console.log('ids', ids);
        setStatus(ids);
        setTimeout(() => {
            refetch();
        }, 100);
    };

    return (
        //isLoading || isFetching
        <LoadingWrap isLoading={false}>
            <div className="p-main">
                <MainHeader
                    onFloorChange={onFloorChange}
                    onChangeStatus={onChangeStatus}
                    data={dataListFloor}
                    floorActive={floorActive}
                    statusRoom={statusRoom}
                />
                <MainContent
                    selectedRoom={selectedRoom}
                    data={dataListRoom}
                    onSelectRoom={onSelectRoom}
                    removeSelectRoom={removeSelectRoom}
                    removeAllSelectRoom={removeAllSelectRoom}
                    refetch={() => {
                        refetch();
                        refetchStatus();
                    }}
                />
                <MainFooter />
            </div>
        </LoadingWrap>
    );
};

export default Main;
